import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { clearNotification } from "../../stores/notifications/index";
import { useAppSelector, useAppDispatch } from "../../stores/store";

const NotificationBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { messages } = useAppSelector((state) => state.notifications);

  const makeCloseHandler = (id?: number) => () => {
    dispatch(clearNotification(id || 0));
  };

  return (
    <>
      {" "}
      {messages.map(
        ({ id, message, severity, anchor, autoHideDuration = 6000 }) => (
          <Snackbar
            key={`snackbar-${id}`}
            open={true}
            autoHideDuration={autoHideDuration}
            onClose={makeCloseHandler(id)}
            anchorOrigin={anchor ? anchor : undefined}
          >
            <Alert
              elevation={6}
              variant="filled"
              severity={severity}
              onClose={makeCloseHandler(id)}
              key={id}
            >
              {message}
            </Alert>
          </Snackbar>
        )
      )}
    </>
  );
};

export default NotificationBar;
